import axios from "axios";
import { useEffect, useState } from "react";
import { Save, Workflow } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ErpMapping({ onSaved }) {
  const [rules, setRules] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [groups, setGroups] = useState([]);
  const [notice, setNotice] = useState("");

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/erp/mapping`),
      axios.get(`${API}/accounts`),
      axios.get(`${API}/groups`),
    ]).then(([m, a, g]) => {
      setRules(m.data.rules);
      setAccounts(a.data);
      setGroups(g.data.income);
    }).catch(() => setNotice("Eşleştirme kuralları okunamadı"));
  }, []);

  const set = (index, key, value) =>
    setRules(current => current.map((rule, i) => (i === index ? { ...rule, [key]: value } : rule)));

  const save = async () => {
    try {
      const payload = rules.map(r => ({ ...r, rate_override: r.rate_override === "" || r.rate_override === null ? null : Number(r.rate_override) }));
      const { data } = await axios.put(`${API}/erp/mapping`, { rules: payload });
      setRules(data.rules);
      setNotice("Eşleştirme kuralları kaydedildi");
      onSaved?.();
    } catch (e) {
      setNotice(e?.response?.data?.detail || "Kaydedilemedi");
    }
  };

  if (!rules) return null;

  return (
    <section className="panel erp-mapping" data-testid="erp-mapping">
      <div className="panel-head">
        <div>
          <p className="eyebrow">EŞLEŞTİRME KURALLARI</p>
          <h3>Satış yazılımı → Roimax</h3>
          <small className="hint">Hangi otel ve satış türü, hangi hesap ve gelir grubuna yazılsın. Oran boşsa satış yazılımındaki komisyon oranı kullanılır.</small>
        </div>
        <Workflow size={18}/>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr><th>Otel kodu</th><th>Satış türü</th><th>Hesap</th><th>Gelir grubu</th><th className="right">Sabit oran %</th></tr>
          </thead>
          <tbody>
            {rules.map((rule, index) => (
              <tr key={`${rule.group_code}-${rule.sale_type}`} data-testid={`erp-rule-${rule.group_code}-${rule.sale_type}`}>
                <td><b>{rule.group_code}</b></td>
                <td>{rule.sale_type === "*" ? "diğer tümü" : rule.sale_type}</td>
                <td>
                  <select data-testid={`erp-rule-account-${index}`} value={rule.account} onChange={e => set(index, "account", e.target.value)}>
                    {accounts.map(name => <option key={name} value={name}>{name}</option>)}
                    {!accounts.includes(rule.account) && <option value={rule.account}>{rule.account}</option>}
                  </select>
                </td>
                <td>
                  <select data-testid={`erp-rule-group-${index}`} value={rule.group} onChange={e => set(index, "group", e.target.value)}>
                    {groups.map(name => <option key={name} value={name}>{name}</option>)}
                    {!groups.includes(rule.group) && <option value={rule.group}>{rule.group}</option>}
                  </select>
                </td>
                <td className="right">
                  <input className="rate-cell" type="number" min="0.01" max="100" step="0.01" placeholder="otomatik"
                    data-testid={`erp-rule-rate-${index}`} value={rule.rate_override ?? ""}
                    onChange={e => set(index, "rate_override", e.target.value)}/>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <button className="primary-btn" data-testid="save-erp-mapping" onClick={save}><Save size={15}/> Kuralları kaydet</button>
      {notice && <small className="group-notice" data-testid="erp-mapping-notice">{notice}</small>}
    </section>
  );
}
